
import CustomImage from '~/components/elements/CustomImage';

export default {
  name: 'ReviewsCommentAttachmentImageItem',
  components: {CustomImage},
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClickHandler() {
      console.log('onClickHandler')
      this.$emit('onClick')
    },
  },
}
